var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "entry-menus-search" }, [
    _vm.searchData.length
      ? _c(
          "div",
          { staticClass: "entry-menus-search__cells" },
          _vm._l(_vm.searchData, function (item) {
            return _c(
              "div",
              { key: item.key, staticClass: "entry-menus-search__cell" },
              [
                _c("div", { staticClass: "entry-menus-search__label" }, [
                  _vm._v(_vm._s(_vm._f("menuLocalName")(item))),
                ]),
                _c(
                  "div",
                  { staticClass: "entry-menus-search__value" },
                  _vm._l(item.search, function (link) {
                    return _c(
                      "a",
                      {
                        key: link.key,
                        staticClass: "entry-menus-search__link",
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function ($event) {
                            return _vm.handleClick(link.key)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm._f("menuLocalName")(link)))]
                    )
                  }),
                  0
                ),
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "entry-menus-search__empty" },
          [
            _c("a-empty", {
              attrs: {
                image: _vm.image,
                description: _vm.i18nRender("layouts.text.undefined"),
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }